import type { AppDataValue } from './AppData';

export function syncStatus(online: boolean, state: AppDataValue['syncState']) {
  if (state.error) return { label: 'Synchronisierung benötigt Aufmerksamkeit', shortLabel: 'Sync-Fehler', tone: 'error' };
  if (state.running) return { label: 'Serverbestand wird geprüft …', shortLabel: 'Wird synchronisiert …', tone: 'pending' };
  if (!online) return { label: 'Offline – Änderungen vorgemerkt', shortLabel: 'Offline', tone: 'offline' };
  const pending = state.pendingHolds + state.pendingAttachments;
  if (pending) return { label: `${state.pendingHolds} Holds und ${state.pendingAttachments} Anhänge warten`, shortLabel: `${pending} ausstehend`, tone: 'pending' };
  if (!state.lastSyncedAt) return { label: 'Serverbestand noch nicht geprüft', shortLabel: 'Noch nicht geprüft', tone: 'pending' };
  return { label: 'Alles aktuell', shortLabel: 'Alles aktuell', tone: 'success' };
}
